import { useNavigate } from 'react-router-dom';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditOptionGroup from '../../components/optionGroups/FormAddEditOptionGroup';
import OptionValueManager from '../../components/optionGroups/Values/OptionValueManager';

const CreateOptionGroup = () => {
    const navigate = useNavigate();

    const handleSuccess = (res) => {
        const newId = res?.data?.data?.id;
        if (newId) {
            // Redirect to edit page of the new group to allow adding values
            navigate(`/option-groups/${newId}/edit`, { replace: true });
        } else {
            navigate('/option-groups');
        }
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditOptionGroup
                isEdit={false}
                onSubmitSuccess={handleSuccess}
            />

            {/* Option Values Management - Disabled in create mode */}
            <OptionValueManager isCreateMode={true} />
        </WrapperSection>
    );
};

export default CreateOptionGroup;
